export default __webpack_public_path__ + "static/media/content_tab01_03.fee37860.jpg";